export { default as PromotionCategoryList } from './PromotionCategoryList';
export { default as PromotionCategoryEdit } from './PromotionCategoryEdit';
export { default as PromotionCategoryCreate } from './PromotionCategoryCreate';


// WEBPACK FOOTER //
// ./src/modules/PromotionCategory/pages/index.ts